import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_MEMBER_ALERT_COUNT_REQUEST: '',
  GET_MEMBER_ALERT_COUNT_SUCCESS: '',
  GET_MEMBER_ALERT_COUNT_FAILURE: '',

  GET_MEMBERS_FOR_ALERTS_ROW_1_REQUEST: '',
  GET_MEMBERS_FOR_ALERTS_ROW_1_SUCCESS: '',
  GET_MEMBERS_FOR_ALERTS_ROW_1_FAILURE: '',

  GET_MEMBERS_FOR_ALERTS_ROW_2_REQUEST: '',
  GET_MEMBERS_FOR_ALERTS_ROW_2_SUCCESS: '',
  GET_MEMBERS_FOR_ALERTS_ROW_2_FAILURE: '',

};

types = setStoreTypeValues(types, 'eligibilityMembers');

export default types;
